import {getToken} from 'firebase/messaging';
import {messaging} from './firebase';

//this key could be generated from firebase console fcm > web push certificates option
const vapidKey = 'BIo2S11KfGBU36qj5KyARhrdT--YLHCwKEdS_NQd-vR_znfCWkyj5SeoAD4WMKEp_F6lF1rVZCP9xI1W_xZpm6w';

export {messaging};

export const getFirebaseToken = () => {
    return getToken(messaging, {vapidKey})
        .then(currentToken => {
            if (currentToken) {
                return currentToken;
            }
        })
        .catch(err => {
            console.error('An error occurred while retrieving token.');
        });
};
export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            await getToken(messaging, {
                vapidKey: vapidKey,
            });
        } else {
            console.error("Notification permission denied");
        }
    } catch (error) {
        console.error("Error retrieving token:", error);
    }
};